module.exports = __webpack_public_path__ + "img/Cape Verde.6c8049de.svg";